import React, { useState, useEffect } from "react";
import ReactDropdown from "react-dropdown";
import { KiemKhoCombo } from "../../constants/kiemKhoConst";
import { useSelector, useDispatch } from "react-redux";
import { getListKiemKho, updateDataSearch } from "../../actions/KiemKho";
import KiemKhoApi from "../../service/kiemKhoApi";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { DanhSachTaiSanCombo } from "../../constants/danhSachTaiSanConst";
import StoreApi from "../../service/storeApi";
export const SearchBarDesktop = ({ onChangeCode, onLuuKiemKho,listDaKiemKho }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchKiemKho); //dataSearchTaiSan dinh nghia o rootreducer
  const onChangeKho = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    dataSearch.kho = e.target.value;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        kho: e.target.value,
      })
    );
    dispatch(getListKiemKho(dataSearch));
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const onChangTrangThai = (field) => (e) => {
    dataSearch.trangThai = e.target.value;
    dataSearch.ListDaKiemKho= listDaKiemKho;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        trangThai: e.target.value,
      })
    );
    dispatch(getListKiemKho(dataSearch));
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);
  useEffect(() => {
    StoreApi.comboAll({}).then((response) => {
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo([
        {
          value: 0,
          label: "Chọn Kho",
        },
        ...dataComboReturn,
      ]);
    });

  }, []);
  const handleFocus = (e) => {
    e.target.select();
  };
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        {/* <div className="input-sm-new input-new-25">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Mã tài sản"
            // onChange={onChangeData}
            //  onKeyDown={handleKeyDown}
            onFocus={handleFocus}
            autoFocus={true}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                onChangeCode(e.target.value);
                handleFocus(e);
              }
            }}
          />
        </div> */}

        <div className="input-sm-new input-new-18">
            <label className="font-color-default font-bold">Kho</label>
          <select
            name="kho"
            className="selectBox form-control input-sm"
            value={dataSearch.kho}
            onChange={onChangeKho("kho")}
          >
            {dataCombo &&
              dataCombo.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>


          {/* <ReactDropdown
            options={KiemKhoCombo.KhoCombo}
            onChange={onSelectCombo}
            value={KiemKhoCombo.KhoDefault}
            placeholder="Select an option"
            controlClassName="form-control input-sm"
          /> */}
        </div>

        <div className="input-sm-new input-new-18">
            <label className="font-color-default font-bold">Trạng thái</label>
          <select
            name="trangThai"
            className="selectBox form-control input-sm"
            value={dataSearch.trangThai}
            onChange={onChangTrangThai("trangThai")}
          >
            {KiemKhoCombo.TrangThaiKiemCombo &&
              KiemKhoCombo.TrangThaiKiemCombo.map((item, idx) => (
                <option key={"objComboTrangThai" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>

          {/* <ReactDropdown
            onChange={onChangTrangThai("trangThai")}
            options={KiemKhoCombo.TrangThaiKiemCombo}
            value={KiemKhoCombo.TrangThaiKiemDefault}
            placeholder="Select an option"
            controlClassName="form-control input-sm"
          /> */}
        </div>

        {/* <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new">
            <i className="la la-search"></i>
          </button>
        </div> */}
      </div>
    </>
  );
};
